enum ErrorCode {
  BadRequest = 400,
  Unauthorized = 401,
  PaymentRequired = 402,
  Forbidden = 403,
  NotFound = 404,
  MethodNotAllowed = 405,
  NotAcceptable = 406,
  ProxyAuthenticationRequired = 407,
  RequestTimeout = 408,
  Conflict = 409,
  Gone = 410,
  LengthRequired = 411,
  PreconditionFailed = 412,
  PayloadTooLarge = 413,
  UriTooLong = 414,
  UnsupportedMediaType = 415,
  RangeNotSatisfiable = 416,
  ExpectationFailed = 417,
  ImATeapot = 418,
  MisdirectedRequest = 421,
  UnprocessableEntity = 422,
  Locked = 423,
  FailedDependency = 424,
  TooEarly = 425,
  UpgradeRequired = 426,
  PreconditionRequired = 428,
  TooManyRequests = 429,
  RequestHeaderFieldsTooLarge = 431,
  UnavailableForLegalReasons = 451,
  InternalServerError = 500,
  NotImplemented = 501,
  BadGateway = 502,
  ServiceUnavailable = 503,
  GatewayTimeout = 504,
  HttpVersionNotSupported = 505,
  VariantAlsoNegotiates = 506,
  InsufficientStorage = 507,
  LoopDetected = 508,
  NotExtended = 510,
  NetworkAuthenticationRequired = 511,
  Unknown,
}

class ErrorResponse extends Error {
  code: ErrorCode;
  type: string;

  constructor(
    code: ErrorCode = ErrorCode.Unknown,
    type?: string,
    message?: string,
  ) {
    super(message);
    this.code = code;
    this.type = type ?? '';
  }
}

class UnknownErrorResponse extends Error {
  type?: string;

  constructor(message: string) {
    super(message);
    this.type = 'UnknownError';
  }
}

class ValidationErrorResponse extends ErrorResponse {
  field: string | string[];

  constructor(
    code: ErrorCode,
    type: string,
    message: string,
    field: string | string[],
  ) {
    super(code, type, message);
    this.field = field;
    this.type = 'ValidationError';
  }
}

export type PaymentRequiredResponseData = {
  overage: string;
  totalCost: string;
};

class PaymentRequiredErrorResponse extends ErrorResponse {
  data: PaymentRequiredResponseData;

  constructor(
    code: ErrorCode,
    type: string,
    message: string,
    data: PaymentRequiredResponseData,
  ) {
    super(code, type, message);
    this.data = data;
    this.type = 'PaymentRequiredError';
  }
}

type ErrorResult =
  | Error
  | ValidationErrorResponse
  | UnknownErrorResponse
  | PaymentRequiredErrorResponse;

const isValidationError = (error: ErrorResult) =>
  error instanceof ValidationErrorResponse;

export {
  type ErrorResult,
  ErrorResponse,
  ValidationErrorResponse,
  PaymentRequiredErrorResponse,
  UnknownErrorResponse,
  isValidationError,
  ErrorCode,
};
